import {useState, useEffect} from 'react'
import {toast} from 'react-toastify'

import {AxiosError} from 'axios'

import {useIntl} from 'react-intl'
import {useSelectDeviceId, useSelectInputSectionValue} from '../../../_metronic/layout/core'
import {awsHomePublishData, awsHomePublishDataMulti} from '../../modules/auth/core/_requests'

function CheckBox({item, index1, index2, title, deviceCode, experimentId, circuitId}: any) {
  // const localSelectDevice = Number(window.localStorage.getItem('selectDevice'))
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  const [checkboxValues, setCheckboxValues] = useState(item.map(() => false))
  const [checkChangeControl, setCheckChangeControl] = useState(false)
  const {SelectInputSectionValue, setSelectInputSectionValue} = useSelectInputSectionValue()
  const {SelectDeviceId} = useSelectDeviceId()
  const intl = useIntl()

  const UnsuccessfulNotify = (message: string) =>
    toast.error(`${message}`, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    })

  useEffect(() => {
    setCheckboxValues(item.map(() => false))
  }, [item])

  const handleCheckboxChange = (index: number) => {
    if (localSelectDevice) {
      setCheckboxValues((prevValues: any) =>
        prevValues.map((value: any, i: any) => (i === index ? !value : value))
      )
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  const sendAwsData = async (numArr: any) => {
    try {
      /* const deviceId = localSelectDevice ?? 0
      const {data} = await awsPublishData(deviceId, {
        device: deviceCode,
        degerlers: numArr,
      })*/

      if (SelectDeviceId.length > 0) {
        /* const requests = SelectDeviceId.map(async (id) => {
          try {
            // Her bir id için ayrı ayrı awsPublishData fonksiyonunu çağırıyoruz
            const response = await awsHomePublishData(id, experimentId, circuitId, {
              device: deviceCode,
              degerlers: numArr,
            })
            return response.data
          } catch (err) {
            // İstek sırasında bir hata olursa, hata nesnesini diziye ekliyoruz
            return Promise.reject(err)
          }
        })*/
        const {data} = await awsHomePublishDataMulti(experimentId, circuitId, SelectDeviceId, {
          device: deviceCode,
          degerlers: numArr,
        })

        // Tüm istekler tamamlandığında çalışacak kod
        //  const results = await Promise.all(requests)
        //  console.log(results) // Tüm sonuçları görebilirsiniz
      } else {
        console.error('SelectDeviceId boş!')
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  function getTrueIndexes(array: any) {
    const indexes: number[] = []
    array.forEach((item: any, index: any) => {
      if (item === true) {
        indexes.push(index)
      }
    })
    return indexes
  }

  function handleSetList(value: any) {
    const newData = SelectInputSectionValue // controlList'in kopyasını oluşturuyoruz
    if (newData && newData[index1] && newData[index1][index2]) {
      newData[index1][index2] = value
    } else {
      console.error('Geçersiz indeksler!')
    }
    return newData
  }

  function printValues(trueIndexes: any) {
    let printData: number[][] = []
    trueIndexes.forEach((index: any) => {
      let value = item[index].value
      const regex = /\[(.*?)\]/g
      let match
      const result: any = []
      while ((match = regex.exec(value))) {
        let str = match[1]
        let data = str.split(',').map(Number)
        result.push(data)
      }
      result.forEach((data: any) => {
        printData.push(data)
      })
    })
    /* Buradan sonra işlem kodları eklenecek*/
    let newList = handleSetList(printData)
    let sendValue = flattenNestedArray(newList)
    setSelectInputSectionValue(newList)
    sendAwsData(sendValue)
    //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
    //  console.log(printData)
    //
  }

  type NestedArray = (number | NestedArray)[]

  function flattenNestedArray(arr: NestedArray): number[] {
    const result: number[] = []

    if (arr.length > 0) {
      arr.forEach((item1: any) => {
        if (Array.isArray(item1) && item1.length > 0) {
          item1.forEach((item2) => {
            if (Array.isArray(item2) && item2.length > 0) {
              item2.forEach((value) => {
                result.push(value)
              })
            }
          })
        }
      })
    }
    return result
  }

  useEffect(() => {
    /* if (checkboxValues.includes(true)) {
      const trueIndexes = getTrueIndexes(checkboxValues)
      printValues(trueIndexes)
    }*/
    if (checkChangeControl) {
      const trueIndexes = getTrueIndexes(checkboxValues)
      printValues(trueIndexes)
      setCheckChangeControl(false)
    }
  }, [checkboxValues, checkChangeControl])

  const CheckBoxItem = item.map((item: any, index: number) => (
    <div
      className='d-flex align-items-center form-check form-check-danger form-check-solid me-5 col-12 my-4'
      key={item.id}
    >
      <input
        className='form-check-input  h-30px w-30px me-2'
        type='checkbox'
        name={`flexCheckBox`}
        id={`flexCheckBox${item.id}`}
        checked={checkboxValues[index]}
        onChange={() => (handleCheckboxChange(index), setCheckChangeControl(true))}
      />

      <label className='form-check-label fw-bold' htmlFor={`flexCheckBox${item.id}`}>
        {item?.key}
      </label>
    </div>
  ))

  return (
    <div
      className='col-xl-4 col-12 sal-animate'
      data-sal-delay='200'
      data-sal='slide-up'
      data-sal-duration='500'
    >
      <div className='card card-flush h-100' style={{backgroundColor: '#FFE896'}}>
        <div className='card-header pt-5'>
          <h3 className='card-title text-gray-800 fw-bolder'>{title}</h3>
        </div>
        <div className='card-body pt-0'>
          <div className='d-flex mt-3 justify-content-between p-5 rounded bg-body row'>
            {CheckBoxItem}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheckBox
